export class Query {
  uuid:string;
  data:any;

  constructor(fullQuery:any, uuid: string) {
    this.data = fullQuery;
    this.uuid = uuid;
  }
}
